import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import Routes from './routes'
import './css/main.css'

ReactDOM.render(<Routes />, document.getElementById('root'))
reportWebVitals()
